const isEnterKeydown = (e: KeyboardEvent) => {
  return e.type === 'keydown' && (e.code === 'Enter' || e.keyCode === 13);
};

const isSpaceKeydown = (e: KeyboardEvent) => {
  return e.type === 'keydown' && (e.code === 'Space' || e.keyCode === 32);
};

const isSpacebarSelectableElement = (e: KeyboardEvent) => {
  return (
    (e.target as HTMLElement).tagName.toLowerCase() === 'button' ||
    (e.target as HTMLElement).getAttribute('role') === 'button'
  );
};

const isEligibleSpaceKeydown = (e: KeyboardEvent) => {
  return isSpaceKeydown(e) && isSpacebarSelectableElement(e);
};

export const isSelectionInteraction = (e: KeyboardEvent) => {
  return e.type === 'click' || isEnterKeydown(e) || isEligibleSpaceKeydown(e);
};
